import type { RootState } from '../../../store'

export const selectConsentsState = (state: RootState) => state.consents
export const selectConsentsItems = (state: RootState) => state.consents.items
export const selectConsentsLoading = (state: RootState) => state.consents.loading
export const selectRevokingConsentId = (state: RootState) => state.consents.revokingConsentId
export const selectConsentsError = (state: RootState) => state.consents.error
